export default __webpack_public_path__ + "static/media/prev.f91efca0.svg";